import { useRecoilState } from "recoil";
import { docSaveState } from "../stats/document-core/atoms";

export function useDocSaveProgress() {
  const [progress, setProgress] = useRecoilState(docSaveState);

  return [progress, setProgress] as const;
}
